<div class="drop-overlay" [class.drop-overlay--active]="isReadyToDrop">
  <span class="drop-overlay__message"><ng-content></ng-content></span>
</div>
